import React, { useState } from 'react';
import './PerformancePulse.css';

const PerformancePulse = () => {
  // Dummy data for now
  const [performance, setPerformance] = useState('green'); // 'green', 'yellow', 'red'

  const getPulseColor = () => {
    if (performance === 'green') return 'pulse-green';
    if (performance === 'yellow') return 'pulse-yellow';
    return 'pulse-red';
  };

  return (
    <div className="performance-pulse">
      <h2>Performance Pulse</h2>
      <div className={`pulse-indicator ${getPulseColor()}`}></div>
      <p>Your current performance is {performance}.</p>
    </div>
  );
};

export default PerformancePulse;